import * as Mod1 from "./discourse/components/lazy-iframe";
import * as Mod2 from "./discourse/components/lazy-video";
import * as Mod3 from "./discourse/initializers/lazy-videos-admin-plugin-configuration-nav";
import * as Mod4 from "./initializers/lazy-videos";
import * as Mod5 from "./lib/lazy-video-attributes";
const compatModules = {
  "discourse/components/lazy-iframe": Mod1,
  "discourse/components/lazy-video": Mod2,
  "discourse/initializers/lazy-videos-admin-plugin-configuration-nav": Mod3,
  "initializers/lazy-videos": Mod4,
  "lib/lazy-video-attributes": Mod5,
};
export default compatModules;
